import { combineReducers } from "@reduxjs/toolkit";

import { propertyListingReducer } from "./PropertyListingSlice";

export const propertiesReducer = combineReducers({
  propertyListing: propertyListingReducer,
});
